/**
 * Segment toggle at the top of the CoAs page. Switches between the two CoA
 * views while preserving the current filter / search query string so the back
 * link and shared filters survive the hop:
 *
 *   Certificates  -> /compliance/coas          (CoAsList, the filed grid)
 *   Missing CoAs   -> /compliance/coas/missing  (MissingCoas, the expected-PO gaps)
 *
 * The two views own different filter params, so the preserved query string is
 * harmless on either side (unknown params are ignored by each page's reader).
 */

import { Link, useLocation } from 'react-router-dom';

const TABS = [
  { to: '/compliance/coas', label: 'Certificates' },
  { to: '/compliance/coas/missing', label: 'Missing CoAs' },
] as const;

export function CoasTabs() {
  const location = useLocation();
  const active = location.pathname;
  const search = location.search;
  return (
    <div className="mb-4 flex gap-1 border-b border-amp-line dark:border-amp-dark-line">
      {TABS.map((tab) => {
        const isActive = active === tab.to;
        return (
          <Link
            key={tab.to}
            to={{ pathname: tab.to, search }}
            className={`-mb-px border-b-2 px-3 py-2 text-sm ${
              isActive
                ? 'border-amp-ink text-amp-ink font-medium dark:border-amp-dark-ink dark:text-amp-dark-ink'
                : 'border-transparent text-amp-ink-muted hover:text-amp-ink dark:text-amp-dark-ink-muted dark:hover:text-amp-dark-ink'
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </div>
  );
}
